import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import * as api from "../api";

function ContactButton({
  exposantId,
  annonceId,
  annonceNom,
  annonceImage,
  label = "Contacter le vendeur",
  style = {}
}) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!user) {
      navigate("/connexion");
      return;
    }
    if (user.id === exposantId) return;

    setLoading(true);
    try {
      const res = await api.sendMessage({
        receiverId: exposantId,
        annonceId: annonceId,
        annonceNom: annonceNom,
        annonceImage: annonceImage || "",
        texte: `Bonjour, je suis intéressé par votre annonce "${annonceNom}".`
      });
      // ✅ CORRECTION : lire correctement le conversationId
      const convId = res.data?.conversationId || res?.conversationId;
      if (convId) {
        navigate(`/messages/${convId}`);
      } else {
        navigate("/messages");
      }
    } catch (err) {
      console.error(err);
      navigate("/messages");
    } finally {
      setLoading(false);
    }
  };

  const defaultStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "14px",
    backgroundColor: loading ? "#9ca3af" : "#0d9488",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: loading ? "not-allowed" : "pointer",
    width: "100%",
    transition: "background 0.2s"
  };

  return (
    <button
      onClick={handleClick}
      disabled={loading || user?.id === exposantId}
      style={{ ...defaultStyle, ...style }}
    >
      {loading ? (
        <>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
            style={{ animation: "spin 1s linear infinite" }}>
            <circle cx="12" cy="12" r="10" strokeOpacity="0.3"/>
            <path d="M12 2a10 10 0 0110 10"/>
          </svg>
          Ouverture...
        </>
      ) : (
        <>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
          </svg>
          {user?.id === exposantId ? "Votre annonce" : label}
        </>
      )}
    </button>
  );
}

export default ContactButton;